import gql from 'graphql-tag';

/**
 * Data of the block project-calculation ("Kalkulation – intern"): its 17 top-level fields plus
 * the settings defaults it shows. Read through `Project.blocks.calculationInternal`, which checks
 * the block's read permission. Plant power, area and the effective values are read from the
 * stored project.
 */
export const PROJECT_CALCULATION_INTERNAL_FIELDS = gql`
  fragment projectCalculationInternalFields on ProjectCalculationInternalBlock {
    id
    number
    vatPercentageState
    generalBusinessCosts
    profitMargin
    costCalculationBasis
    calculatedExternalCost
    projectRightsCost
    oneTimeLeaseCostDriver
    oneTimeLeaseCostPerkWp
    oneTimeLeaseCostPerSquareMeter
    additionalProfitMargin
    baseSettlementValuePerkWp
    baseSettlementValue
    commissionPercentage
    calculatedProvision
    calculatedSettlementValueDriver
    calculatedSettlementValue
    calculatedSettlementValuePerkWp
    settingsDefaults {
      profitMargin
      generalBusinessCosts
      commissionPercentage
    }
  }
`;
